import { ThemeEvents } from '@theme/events';

let refreshFrame = null;
let refreshTimer = null;

function normaliseModel(value) {
  return String(value || '')
    .trim()
    .replace(/^apple\s+/i, '')
    .toLowerCase();
}

function getContexts(dialog) {
  const contexts = new Map();

  for (const node of dialog.querySelectorAll('script[data-cart-model-line]')) {
    if (!(node instanceof HTMLScriptElement)) continue;

    try {
      const context = JSON.parse(node.textContent || '{}');
      if (!context.lineKey || !context.currentModel) continue;
      contexts.set(String(context.lineKey), context);
    } catch {
      // Ignore malformed model data for this line only.
    }
  }

  return contexts;
}

function trimCartTitles() {
  for (const component of document.querySelectorAll('cart-items-component')) {
    const dialog = component.querySelector('cart-model-change-dialog');
    if (!(dialog instanceof HTMLElement)) continue;

    const contexts = getContexts(dialog);

    for (const row of component.querySelectorAll('.cart-items__table-row[data-key]')) {
      if (!(row instanceof HTMLElement)) continue;

      const lineKey = row.dataset.key;
      if (!lineKey) continue;

      const context = contexts.get(String(lineKey));
      if (!context?.currentModel) continue;

      const title = row.querySelector('.cart-items__title');
      if (!(title instanceof HTMLElement)) continue;

      const visibleTitle = (title.textContent || '').trim();
      const separatorIndex = visibleTitle.lastIndexOf(' - ');
      if (separatorIndex === -1) continue;

      const suffix = visibleTitle.slice(separatorIndex + 3).trim();
      if (normaliseModel(suffix) !== normaliseModel(context.currentModel)) continue;

      title.textContent = visibleTitle.slice(0, separatorIndex).trim();
    }
  }
}

function wakeModelSwitchers() {
  for (const dialog of document.querySelectorAll('cart-model-change-dialog')) {
    if (!(dialog instanceof HTMLElement)) continue;

    // cart-model-change.js already watches its cart component with a MutationObserver.
    // A tiny temporary mutation makes it reload the latest line JSON and re-inject
    // controls after Shopify has morphed the drawer/page HTML.
    const marker = document.createElement('span');
    marker.hidden = true;
    marker.dataset.cartModelSync = '';
    dialog.append(marker);
    marker.remove();
  }
}

function refreshModelUI() {
  trimCartTitles();
  wakeModelSwitchers();

  // Run title cleanup once more after the switcher's own MutationObserver callback.
  queueMicrotask(trimCartTitles);
}

function scheduleModelRefresh() {
  queueMicrotask(refreshModelUI);

  if (refreshFrame !== null) cancelAnimationFrame(refreshFrame);
  refreshFrame = requestAnimationFrame(() => {
    refreshFrame = null;
    refreshModelUI();
  });

  if (refreshTimer !== null) clearTimeout(refreshTimer);
  refreshTimer = window.setTimeout(() => {
    refreshTimer = null;
    refreshModelUI();
  }, 120);
}

document.addEventListener(ThemeEvents.cartUpdate, scheduleModelRefresh);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleModelRefresh, { once: true });
} else {
  scheduleModelRefresh();
}
